<template>
  <div class="home grey lighten-5">
    <div class="row">
      <div class="learners-banner">
        <div class="bg-element" v-bind:style="{backgroundImage:'url('+pattern+')'}" >	</div>
        <div class="col s12">
          <h2 class="" style="z-index: 99; position:relative">Court of Appeal Transcript Request</h2>
          <div class="col s12 l10" style="z-index: 99; position:relative">
            <p style="font-size: 16.5px; z-index: 99;"> We have moved this service to Court's main website. Please visit the website register an account to begin your request.</p> 
            <p>Please note that you are now required to register to access the form to ensure </p>
          </div>
           
          <a href="https://www.eccourts.org/transcript-request-form"  class="btn btn-large rounded waves-effect ">Visit Page</a>

        </div>
      </div>
    </div>
    <div class="row">
    <div class="col s12 l10 no-float center-aligned">
      <div class="modal modal-fixed-footer fm" ref="modal">
        <div class="modal-header white">
           Request for Transcript of Proceedings
        <button class="btn-flat modal-close right btn-floating waves-effect">
          <i class="material-icons grey-text text-darken-3">close</i>
        </button>
        </div>
        <div class="pl-wrapper">
          <div class="progress" v-if="processingRequest">
              <div class="indeterminate"></div>
          </div>
          </div>
        <div class="modal-content">
          
        
          
          <div class="form-fields" v-if="viewType === 'default'">
            <div class="col s12 center">
              <img width="100px" :src="biggerLogo" alt="">
            </div>
            <div :class="field.layout"
              v-for="(field, index) in fields" v-bind:key="index">
              <field-types
              v-if="ready"
              @validate="$_formValidation"
                @uploads="$_filesToUpload($event)"
                @update="$_fieldsData"
                :data-option="field">
              </field-types>
            </div>
          </div>
          <div v-else-if="viewType === 'review'" class="review">
            
          <div :class="field.layout"
              v-for="(field, index) in fields" v-bind:key="index">
            <div class="label-field" v-html="field.label"></div>
            <div class="view-details" v-if="field.name === 'judges'">
             <ol>
               <li v-for="(g, i) in toPost['judges']" :key="i" v-html="g.notes"></li>
             </ol>
            </div>
            <div class="view-details" v-else-if="field.name === 'hearing_dates'" >
               <ol>
               <li v-for="(g, i) in toPost['hearing_dates']" :key="i" v-html="g.notes"></li>
             </ol>
            </div>
            <div class="view-details" v-else-if="field.name === 'transcriptionist'" v-text="field.values.name"></div>
            <div class="view-details" v-else v-html="field.values"></div>
          </div>
          <div class=" clear">
            
          
            <label>
              <input type="checkbox" v-model="verified" />
              <span class="grey-text text-darken-2">Please confirm that you've reviewed all the information entered and is accurate to the best of your knowledge.</span>
            </label>
          
        <div class="clear"></div>

            <br>
            <button :disabled="!verified"  class="btn rounded" style="width:100%;" @click="$_sendRequest()"><i class="material-icons left">send</i> Submit</button>
            <br>
          </div>
          </div>
    <div class="success col s12 l10 push-l1" v-else>
      <div class="success-container center">
       <img src="https://members.eccourts.org/wp-content/uploads/2019/11/android-chrome-512x512.png" style=" width: 160px;">
      </div>
      <div class="success-message center">
        <p>Your request id# {{this.sessionKey}} has been recieved</p>
        <p>Please check your address {{toPost.email}} for a confirmation email.</p>
         <p>Once Your request status is changed you will recieve an update via the address provided. Please keep a copy of your request ID for queries and follow.</p>
        </div>
      <div class="success-actions center">
      <button class="btn rounded btn-medium waves-effect modal-close"><!-- <i class="material-icons left">print</i> --> Close</button>
    </div>
    </div>

        </div>
        <div class="modal-footer white">
          <button 
            @click="viewType === 'default' 
                ? viewType = 'review' 
                : viewType = 'default'" 
            :disabled="!isValidToSubmit"
            v-text="viewType === 'default'
              ? 'Review'
              : 'Edit'"
            class="btn waves-effect rounded"></button>
        </div>
      </div>
     
  
      </div>
    </div>

		<div class="pickers" id="pickerContainer"></div>
  </div>
</template>

<script>
import axios from 'axios'
const sendComment = async (params) => {
    let commentStructure = () => {
      return {
      //  author: 1,
        author_name:'Demetrius Charles',
        author_email: 'dcharles@eccourts.org',
        content: JSON.stringify(params.data),
        post: params.id,
       // status:'approve',
        fields:{
          contents:JSON.stringify(params.data),
        }
      }
    }
    return axios.post('https://members.eccourts.org/wp-json/wp/v2/comments', commentStructure())
  
}
/* const postLoanApplication = (data, token) => {
  let url = `https://members.eccourts.org/wp-json/wp/v2/comments/`
  return axios.post(url, data, {
    headers: {
      "Authorization": 'Bearer ' + token,
    }
  })  
} */
const  generatePassword = () =>{
  var length = 8,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}
import formService from '@/services/formService'
import M from 'materialize-css'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import recordFields from '@/components/transcripts/transcripts-incoming-public'
import pattern from '@/assets/web.svg'

import biggerLogo from '@/assets/bigger-logo.png'
export default {
  name: 'publicRequest',
  components:{
    fieldTypes
  },
  watch: {
    viewType: function () {
        setTimeout(() => {
            M.updateTextFields()
          },150);
    },
  },
  data () {
    return {
      processingRequest: false,
      verified: false,
      biggerLogo,
      successObject: false,
      sessionKey:generatePassword(),
      viewType :'default',
      ready: false,
      validations:{

      },
      modalInstance: null,
      modalOptions: {
        onOpenStart: () =>{
          this.ready = true
        },
        dismissible:false,
        onOpenEnd: () => {
          setTimeout(() => {
            M.updateTextFields()
          },150);
        },
        onCloseEnd: () => {
          this.fields = recordFields.generate()
        }
      },
      fields: {},
      pattern
    }
  },
  created () {
    let x = recordFields.generate()
    this.fields = x
  },
  mounted() {
    this._initModal()
    let eO = {}
    this.fields.filter(x => x.v)
    .forEach(h => {
      eO[h.name] = false
    })
    this.validations = eO
  },
  computed: {
    toPost: {
      get () {
        /*  x.name === 'judges' && x.values.length  ? x.values.map(o => o.notes) : */
         let me = {
           viewId: this.sessionKey,
         }
            this.fields.forEach(x => {
              me[x.name] =  x.values
            })
        return me
      }
    },
    fieldsX:{
      get(){
        return recordFields.generate()
      }
    },
     
    isValidToSubmit: {
      get () {
        return this.validations ? Object.values(this.validations).map(x => x).every(y => y) : false
      }
    }
  },
  methods:{
    $_fieldsData(e){
      let record = this.fields.findIndex(x => x.name === e.name)
      if(record > -1) this.fields[record].values = e.data      
    },
    notificationService (x, id) {
      let payload = {
          id: x,
          requestEmail:this.toPost.email,
          caseName:this.toPost.case_name,
          adminUrl:`https://docs.eccourts.org/incoming-transcripts/${id}`,
          userUrl:'https://docs.eccourts.org',
          requestingParty:this.toPost.requesting_party,
          case_number:this.toPost.case_number,
          transcriptionist:this.toPost.transcriptionist.name,
          practitioners:this.toPost.practitioners,
          _wpcf7_unit_tag:"7eba150",
          heard: this.toPost.heard,
          judges:this.toPost.judges.length > 0 ? this.toPost.judges.map(j => {return `${j.notes}`}) : '',
          appearances:this.toPost.appearances,
          hearing_dates: this.toPost.hearing_dates.length > 0 ? this.toPost.hearing_dates.map(d => {return `${d.notes}`}) : '',
          turn_around_time:this.toPost.turn_around_time+' days',
      }
      formService.newRequest(payload)
      .then( ()=> {
        this.viewType = 'success'     
        this.processingRequest = false
      })
      .catch(err =>{
        window.console.log(err)
        if(err) M.toast({html:`Error please try again later `})
      })
    },
    $_sendRequest () {
      this.processingRequest = true
      let data = {
        data: this.toPost,
        id: 3431
      }
      sendComment (data)
      .then(x => {
        this.successObject = x.data
        //this.sessionKey  = this.sessionKey+`-${x.data.id}`
        this.notificationService(this.sessionKey+`-${x.data.id}`, x.data.id)
      })
      .catch(err =>{
        if(err) M.toast({html:`Error please try again later `})
        this.processingRequest = false
      })
    },
    $_formValidation(e) {
      this.validations[e.key] = e.value
    },
    _initModal (){
      this.modalInstance = M.Modal.init(this.$refs.modal, this.modalOptions)
    },
    $_getSearchResults(){
     /*  let queryVars = this.$refs.appSearch.value
      this.$router.push({name:'search', query:{q:queryVars}}) */
  /*     
      contentService.getSearchResults(query, 33)
      .then(res=>{
        console.log(res)
      })
      .catch(err=>{
        console.log(err)
      }) */
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  min-height: calc(90vh - 56px);
@media screen and (min-width:1024px) {
  width: 100%;
  padding-left:300px;

}
.modal.fm:not(.datepicker) {
  min-height: 90%;
  top: 5% !important;
  max-width: 768px;
  border-radius: 10px;
}
input#appSearch {
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.09), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.02) !important;
    border-radius: 8px;
    margin-top: 34px;
    padding: 0px 24px;
    width: calc(100% - 48px);
}
button.action {
    position: absolute;
    right: 19px;
    bottom: 10px;
}

.learners-banner {
    background:rgb(250, 250, 250);
    padding: 46px 48px;
    background-size: 50%;
    background-position: right top;
    background-repeat: no-repeat;
		height:300px;
		position: relative;
		overflow: hidden;
    @media screen and (max-width:768px) {
      padding: 24px 28px;
    }
    .bg-element {
      position: absolute;
      top:0;
      right:0px;
      height: calc(100% + 64px);
      width:45%;
      background-size: cover !important;
      z-index: 0;
    opacity: .4;
    }
    .user-title {
      font-size:32px;
      margin:12px 0px;
      line-height: 1;
    }
    .short-text {
      p {
        font-size:17px;
        line-height: 1.6; 
        opacity: .9;
        margin:4px 0px 16px;
      }
    }
}

}
.success-container {
    text-align: center;
    padding: 24px 0 10px 0;
    i {
        font-size: 106px;
        text-align: center;
        color: #109d59;
    }
    .success-message {
      text-align: center;
      font-size: 14px;
      padding: 0 10%;
    }
  }
  .label-field {
    font-weight: 500;
    margin: -22px 0px 3px 0px;
    font-size: 15px;
    background: #fafafa;
    z-index: 9;
    position: relative;
    padding: 0 4px;
    float: left;
  }
  .review {
    //border: 1px solid rgba(0,0,0,0.2);
    display: flow-root;
    padding: 24px;
    border-radius: 8px;
    .col {
      position: relative;
      padding: 12px;
      margin-bottom: 22px;
      &::before {
          content: ' ';
          position: absolute;
          left: 3px;
          right: 4px;
          top: 1px;
          bottom: 1px;
          border: 1.2px solid #d0d0d0;
          border-radius: 4px;
      }
      .view-details {
          clear: both;
      }
    }
  }
.pl-wrapper {
    position: absolute;
    left: 0;
    top: 42px;
    right: 0;
}
</style>
<style lang="scss">
.modal.fm:not(.datepicker) {
/*   &.fullscreen {
    top: 10% !important;
    left:
  } */
  .modal-header {
    height: 50px;
    font-size: 16px;
    line-height: 34px;
    padding: 8px 16px;
    border-bottom: 1px solid #d9d9d9;
  }
 /*  .layout-fix {
    padding:0px !important; margin-bottom: 32px !important;
  } */
  .modal-content {
      height: calc(100% - 106px) !important;
/*     .input-field {
      margin-bottom:3rem;
      &::before {
        content: ' ';
        position: absolute;
        left: -20px;
        right: -20px;
        bottom: -20px;
        top: -24px;
        background: #f2f2f2;
        border-radius: 7px;
        z-index: -1;
      }
    } */
    .card {
      .input-field {
      margin-bottom: 0px;
      }
    }
  }
}
</style>